import { render, staticRenderFns } from "./ManageMizodiaFingerprint.vue?vue&type=template&id=73b153f6&scoped=true&"
import script from "./ManageMizodiaFingerprint.vue?vue&type=script&lang=js&"
export * from "./ManageMizodiaFingerprint.vue?vue&type=script&lang=js&"
import style0 from "./ManageMizodiaFingerprint.vue?vue&type=style&index=0&id=73b153f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b153f6",
  null
  
)

export default component.exports